import { Controller } from 'stimulus';
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import toArray from '@/helpers/toArray';

class FormValidationController extends Controller {
  connect() {
    porta({
      target: this.element,
      messages: {
        ...nl,
        rangeUnderflow: 'Deze waarde is te laag.',
        rangeOverflow: 'Deze waarde is te hoog.',
      },
      onValidate: (formElement) => {
        if (this.hasErrorsTarget) {
          this.errorsTarget.hidden = true;
        }

        this.enableSubmitButton(formElement);
      },
      onError: (formElement) => {
        if (this.hasErrorsTarget) {
          this.errorsTarget.hidden = false;
        }

        this.disableSubmitButton(formElement);
      },
    });

    this.initializeEventListeners();
  }

  initializeEventListeners() {
    const fields = this.element.querySelectorAll('input, select, textarea');

    fields.forEach((field) => {
      $(field).on('change keyup keydown', () => this.enableSubmitButton(this.element));
    });
  }

  disableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, false);
  }

  enableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, true);
  }

  // eslint-disable-next-line class-methods-use-this
  toggleSubmitButtonState(formElement, state) {
    toArray(formElement.querySelectorAll('[type="submit"]')).forEach((button) => {
      button[state ? 'removeAttribute' : 'setAttribute']('disabled', 'disabled');
    });
  }

  scrollToError() {
    const errorElement = this.element.querySelector('.porta-error');

    if (errorElement) {
      errorElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }
}

FormValidationController.targets = [
  'errors',
];

export default FormValidationController;
